module.exports = __webpack_public_path__ + "img/teff-flour.ff091872.webp";